module.exports = __webpack_public_path__ + "img/table.ad1b4183.svg";